import { render, staticRenderFns } from "./NewDnsRecord.vue?vue&type=template&id=15fc9980&"
import script from "./NewDnsRecord.vue?vue&type=script&lang=js&"
export * from "./NewDnsRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports